import React from "react";
import { ToastContainer as BaseToastContainer } from "react-toastify";
import { Icon} from '@blueprint/ui';


const ToastContainer = (): JSX.Element => {
    return (
        <BaseToastContainer
            hideProgressBar
            pauseOnHover
            closeOnClick={false}
            closeButton={CloseButton}
            icon={false}
            newestOnTop={true}
        />
    );
};

type CloseButtonProps = {
    closeToast: () => void;
};

const CloseButton = ({ closeToast }: CloseButtonProps): JSX.Element => {
    return (
        <div
            onClick={closeToast}
            className={'d-flex align-items-top pt-3 me-1'}
            tabIndex={0}
            onKeyUp={(event) =>
                {(event.keyCode === 13 || event.keyCode === 32) && closeToast()}
            }
        >
            {/*<CloseIcon />*/}
            <Icon margin="0" name={'Close'} fill={'#fff'} className="me-2 flex-shrink-0" />
        </div>
    );
};

export default ToastContainer;
